import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-maintain',
  templateUrl: './section-maintain.component.html',
  styleUrls: ['./section-maintain.component.css']
})
export class SectionMaintainComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
